import React, { useState } from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';

const ShareLink = ({
	url,
	title = 'Share',
	shareText,
	entityId = null,
	entityType = 'link',
	style = {},
	showCopyButton = true,
	showEntityId = false,
	socialPlatforms = ['email', 'x', 'facebook', 'whatsapp', 'linkedin', 'reddit', 'telegram'],
	showPlayButton = true,
	playButtonText = 'Play',
	playButtonIcon = 'play',
	onShare = null
}) => {
	const [copied, setCopied] = useState(false);
	const [showSocial, setShowSocial] = useState(false);

	const fullUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;
	const defaultShareText = shareText || title;

	const copyToClipboard = () => {
		navigator.clipboard.writeText(fullUrl).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
			if (onShare) onShare('copy', fullUrl);
		});
	};

	const platformConfigs = {
		x: { icon: 'x', color: 'black', url: `https://x.com/intent/tweet?text=${encodeURIComponent(defaultShareText)}&url=${encodeURIComponent(fullUrl)}` },
		facebook: { icon: 'facebook', color: 'facebook', url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}` },
		whatsapp: { icon: 'whatsapp', color: 'green', url: `https://wa.me/?text=${encodeURIComponent(defaultShareText + ' ' + fullUrl)}` },
		linkedin: { icon: 'linkedin', color: 'linkedin', url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}` },
		reddit: { icon: 'reddit', color: 'orange', url: `https://reddit.com/submit?url=${encodeURIComponent(fullUrl)}&title=${encodeURIComponent(defaultShareText)}` },
		telegram: { icon: 'telegram', color: 'teal', url: `https://t.me/share/url?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(defaultShareText)}` },
		email: { icon: 'mail', color: 'grey', url: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(defaultShareText + '\n\n' + fullUrl)}` }
	};

	const openShareWindow = (platform) => {
		const config = platformConfigs[platform];
		if (config) {
			platform === 'email' ? window.location.href = config.url : window.open(config.url, '_blank', 'width=600,height=400');
			if (onShare) onShare(platform, fullUrl);
		}
	};

	return (
		<div style={{ marginTop: '1em', ...style }}>
			{showEntityId && entityId && (
				<div style={{ marginBottom: '0.5em' }}>
					<Label size='small'>{entityType.charAt(0).toUpperCase() + entityType.slice(1)} ID</Label>
					<code style={{ marginLeft: '0.5em', fontSize: '0.9em' }}>{entityId}</code>
				</div>
			)}

			<div style={{ display: 'flex', alignItems: 'center', gap: '0.5em', flexWrap: 'wrap' }}>
				<div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, background: '#f5f5f5', borderRadius: '4px', padding: '0.4em 0.6em' }}>
					<a href={fullUrl} target='_blank' rel='noopener noreferrer' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.9em' }}>
						{fullUrl}
					</a>
				</div>

				{showCopyButton && (
					<Button icon size='small' color={copied ? 'green' : undefined} onClick={copyToClipboard} title={copied ? 'Copied!' : 'Copy link'}>
						<Icon name={copied ? 'check' : 'copy'} />
					</Button>
				)}

				{socialPlatforms.length > 0 && (
					<Button icon size='small' onClick={() => setShowSocial(!showSocial)} title='Share on social media' active={showSocial}>
						<Icon name='share alternate' />
					</Button>
				)}

				{showPlayButton && (
					<Button icon labelPosition='left' size='small' color='green' as='a' href={fullUrl} target='_blank' rel='noopener noreferrer'>
						<Icon name={playButtonIcon} />
						{playButtonText}
					</Button>
				)}
			</div>

			{showSocial && socialPlatforms.length > 0 && (
				<div style={{ marginTop: '0.5em', display: 'flex', gap: '0.3em', flexWrap: 'wrap' }}>
					{socialPlatforms.map(platform => {
						const config = platformConfigs[platform];
						return config ? (
							<Button key={platform} icon size='small' color={config.color} onClick={() => openShareWindow(platform)} title={platform} style={{ boxShadow: 'none', border: 'none', padding: '0.5em' }}>
								<Icon name={config.icon} size='large' style={{ margin: 0 }} />
							</Button>
						) : null;
					})}
				</div>
			)}
		</div>
	);
};

export default ShareLink;
